
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/loans/add",
      function () {
        return require("private-next-pages/account/loans/add/index.p.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/loans/add"])
      });
    }
  